import { Pipe, PipeTransform } from '@angular/core';
import { CompleteMedicalCareStruct } from '../../services/structs/orchestrator-patient/complete-medical-care.struct';
import { SadtStatusEnum } from '../../enum/sadt-status.enum';

@Pipe({
    name: 'validateThereAreExams',
    standalone: false
})
export class ValidateThereAreExamsPipe implements PipeTransform {

  transform(functionName: string, medicalCare: CompleteMedicalCareStruct, isHistory: boolean, idCurrentMedicalCare?: number): boolean {
    switch (functionName) {
      case 'validateGeneral':
        return this.validateGeneral(medicalCare, isHistory, idCurrentMedicalCare);
      case 'validateIndividualList':
        return this.validateIndividualList(medicalCare, isHistory, idCurrentMedicalCare);
      default:
        throw new Error(`Função ${functionName} não implementada.`);
    }
  }

  validateGeneral(medicalCare: CompleteMedicalCareStruct, isHistory: boolean, idCurrentMedicalCare?: number): boolean{
    if(!isHistory) {
      return ((medicalCare.medicalCareSadt.length > 0 
          && medicalCare.medicalCareSadt.filter(x => x.canSuspend).length > 0));
    }
    if(isHistory) {
      return ((medicalCare.medicalCareSadt.length > 0 
          && medicalCare.medicalCareSadt.filter(x => x.idStatus == SadtStatusEnum.Suspenso && x.idMedicalCareSuspended == idCurrentMedicalCare).length > 0));
    }
  }

  validateIndividualList(medicalCare: CompleteMedicalCareStruct, isHistory: boolean, idCurrentMedicalCare?: number): boolean {
    return isHistory ? 
      medicalCare.medicalCareSadt.filter(x => x.idStatus == SadtStatusEnum.Suspenso && x.idMedicalCareSuspended == idCurrentMedicalCare).length > 0
      : medicalCare.medicalCareSadt.filter(x => x.canSuspend).length > 0;
  }
}

